
export default (props) => [
    {
        name: "Data Criação",
        options: {
            display: "false",
            download: false,
        },
        sort: true,
    },
    {
        name: "Codigo",
        options: {
            display: "false",
            download: false,
        }
    },
    'Descrição',
];